/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const userAccessesSchema = z.object({
      "legacyIpro": z.boolean().describe("Membre du groupe Keycloak /Logiciels/ImmonotPro / Premium/Roles/Accès"),
  "siteEtude": z.boolean().describe("Membre du groupe Keycloak /Logiciels/Site Etude/Roles/Accès"),
  "nsVoice": z.boolean().describe("Membre du groupe Keycloak /Logiciels/NS Voice/Roles/Accès")
      })